// import React from 'react';
// import ReactDOM from 'react-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'mdb-react-ui-kit/dist/css/mdb.min.css';
// import "@fortawesome/fontawesome-free/css/all.min.css";
// // import $ from 'jquery';
// // import Popper from 'popper.js';


// import 'bootstrap/dist/js/bootstrap.bundle.min';
// // import './index.css';
// import './assets/scss/all.css'
// import App from './App';
// import { AuthProvider } from './context/AuthProvider';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';


// global.SERVER_URL = 'http://localhost:3500';
// global.__basedir = __dirname;

// ReactDOM.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <AuthProvider>
//         <Routes>
//           <Route path="/*" element={<App />} />
//         </Routes>
//       </AuthProvider>
//     </BrowserRouter>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './assets/scss/all.css'
import App from './App';
import { AuthProvider } from './context/AuthProvider';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

global.__basedir = __dirname;

// const getBaseUrl = () => {
//   if (process.env.REACT_APP_NODE_ENV === "development") {
//     return `http://${process.env.REACT_APP_LOCAL_URL}:${process.env.REACT_APP_SERVER_PORT}`; // Use localhost for development
//   }
//   else if (process.env.REACT_APP_NODE_ENV === "staging") {
//     return `http://${process.env.REACT_APP_STAGING_URL}:${process.env.REACT_APP_SERVER_PORT}`; // Use localhost for development
//   }
//   else {
//     return `http://${process.env.REACT_APP_PRODUCTION_URL}:${process.env.REACT_APP_SERVER_PORT}`; // Use server IP for other environments
//   }
// };

// global.SERVER_URL = getBaseUrl();

// UAT Server Base URL
// global.SERVER_URL = 'http://3.111.185.105:3502';

// Production Server Base URL
global.SERVER_URL = 'https://workwiseserve.shardatech.org';


createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <BrowserRouter basename="/">
      <AuthProvider>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  // </React.StrictMode>
);

/** Production Server Code While Creating A Build */
// createRoot(document.getElementById('root')).render(
//     <BrowserRouter basename="/workwise">
//       <AuthProvider>
//         <Routes>
//           <Route path="/*" element={<App />} />
//         </Routes>
//       </AuthProvider>
//     </BrowserRouter>
// );
